module.exports = __webpack_public_path__ + "static/media/jq.4131c193.png";